import { Box } from '@chakra-ui/react';

import { components as ReactSelectComponents, OptionProps } from 'react-select';
import { OptionType } from '../../../Types';
import { TooltipWrapper } from './TooltipWrapper.component';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const OptionWithTooltip = ({
    isSelected,
    children,
    ...rest
}: OptionProps<OptionType, boolean>): JSX.Element => {
    return (
        <TooltipWrapper
            label={children}
            openDelay={500}
            isDisabled={!rest.selectProps?.hasTooltip}
            placement="bottom-start"
        >
            <ReactSelectComponents.Option isSelected={isSelected} {...rest}>
                <Box overflow="hidden" textOverflow="ellipsis">
                    {children}
                </Box>
            </ReactSelectComponents.Option>
        </TooltipWrapper>
    );
};
